import { useContext } from 'react';
import { PostPageContext } from './PostPageContext';
import type { PostPageContextType } from './PostPageContext';

export const usePostPageContext = () => {
  const context = useContext<PostPageContextType | undefined>(PostPageContext);
  if (!context) {
    // no longer warn about missing context
    // since it's used in PostCards on the home page
  }
  return context;
};
